import Add16 from '@carbon/icons-react/es/add/16';
import { Col, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { ProjectId } from 'api/models';
import { Project } from 'api/project';
import { Button } from 'components/atoms/button';
import { IconShell } from 'components/atoms/icon-shell';
import { Loading } from 'components/atoms/loading';
import { useMemberships } from 'hooks/use-memberships';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { useJoinProject } from '../use-join-project';
import { FooterContainer, LinkText, SettingsIcon } from './footer.styles';

export const Footer = ({
  project,
  clickHandler,
}: {
  project: Pick<Project, 'projectId' | 'projectName'>;
  clickHandler(visibility: boolean): void;
}) => {
  const { projectId } = project;
  const { user } = useUser();
  const [status, membership] = useMemberships(ProjectId(projectId));
  const hasMembership = membership?.users.includes(user.userId);
  const { isLoading, handleProjectJoin } = useJoinProject(projectId);

  const invitationString = useTranslation('invitation.manage_team_members');
  const hereText = useTranslation('here');
  const inviteButtontext = useTranslation('invitation.join_project');

  if (status === 'loading') {
    return (
      <FooterContainer>
        <Loading />
      </FooterContainer>
    );
  }

  if (hasMembership) {
    return (
      <Row align="middle" justify="start">
        <Col>
          <IconShell icon={<SettingsIcon />} size="xsmall" />
        </Col>
        <Col>{invitationString}</Col>
        <Col>
          <Link
            to={`/projects/${projectId}/settings/members`}
            onClick={() => clickHandler(false)}
            data-cy="navigate.to.team.members.btn"
          >
            <LinkText>{hereText.toLowerCase()}</LinkText>
          </Link>
        </Col>
      </Row>
    );
  }

  return (
    <FooterContainer>
      <Button
        type="primary"
        icon={<Add16 />}
        iconPlacement="left"
        loading={isLoading}
        onClick={handleProjectJoin}
      >
        {inviteButtontext}
      </Button>
    </FooterContainer>
  );
};
